// source: stailer/externaladminrpc/order_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var stailer_externaladminrpc_delivery_time_pb = require('../../stailer/externaladminrpc/delivery_time_pb.js');
goog.object.extend(proto, stailer_externaladminrpc_delivery_time_pb);
var type_bundled_item_pb = require('../../type/bundled_item_pb.js');
goog.object.extend(proto, type_bundled_item_pb);
var type_container_type_pb = require('../../type/container_type_pb.js');
goog.object.extend(proto, type_container_type_pb);
var type_order_pb = require('../../type/order_pb.js');
goog.object.extend(proto, type_order_pb);
var type_order_receive_method_pb = require('../../type/order_receive_method_pb.js');
goog.object.extend(proto, type_order_receive_method_pb);
var type_orderer_info_pb = require('../../type/orderer_info_pb.js');
goog.object.extend(proto, type_orderer_info_pb);
var type_price_type_pb = require('../../type/price_type_pb.js');
goog.object.extend(proto, type_price_type_pb);
var type_shipping_info_pb = require('../../type/shipping_info_pb.js');
goog.object.extend(proto, type_shipping_info_pb);
var type_transaction_product_pb = require('../../type/transaction_product_pb.js');
goog.object.extend(proto, type_transaction_product_pb);
var type_external_admin_ip_option_pb = require('../../type/external_admin_ip_option_pb.js');
goog.object.extend(proto, type_external_admin_ip_option_pb);
goog.exportSymbol('proto.stailer_external_admin.CalculateToUpdateRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.CalculateToUpdateResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.CancelOrderRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.CancelOrderResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ReasonCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.ResultCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderToUpdateRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderToUpdateResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem', null, global);
goog.exportSymbol('proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ConditionCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsDeliveryTime', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsPeriod', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsRequest.ConditionCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsResponse.ResponseTypeCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsResponse.Result', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsStreamRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsStreamRequest.ConditionCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsStreamResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderUsersRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderUsersResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersRequest.View', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.SearchOrdersResponse.OrderSummary', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.AddProduct', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.CalculationResult', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.CustomProduct', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.DisableUpdateReason', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.FixDeliveryFee', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrder.UpdateProduct', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderRequest', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse.ResultCase', null, global);
goog.exportSymbol('proto.stailer_external_admin.UpdateOrderResponse.Success', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderRequest.displayName = 'proto.stailer_external_admin.GetOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderResponse.displayName = 'proto.stailer_external_admin.GetOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderUsersRequest.displayName = 'proto.stailer_external_admin.SearchOrderUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.SearchOrderUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderUsersResponse.displayName = 'proto.stailer_external_admin.SearchOrderUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.displayName = 'proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrdersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.SearchOrdersRequest.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrdersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrdersRequest.displayName = 'proto.stailer_external_admin.SearchOrdersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrdersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.SearchOrdersResponse.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrdersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrdersResponse.displayName = 'proto.stailer_external_admin.SearchOrdersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrdersResponse.OrderSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.displayName = 'proto.stailer_external_admin.SearchOrdersResponse.OrderSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.ChangeDeliveryTimeRequest.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeRequest.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.ChangeDeliveryTimeResponse.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.displayName = 'proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.CancelOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.CancelOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.CancelOrderRequest.displayName = 'proto.stailer_external_admin.CancelOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.CancelOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.CancelOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.CancelOrderResponse.displayName = 'proto.stailer_external_admin.CancelOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.displayName = 'proto.stailer_external_admin.UpdateOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder.CustomProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.CustomProduct.displayName = 'proto.stailer_external_admin.UpdateOrder.CustomProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.UpdateOrder.UpdateProduct.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder.UpdateProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.UpdateProduct.displayName = 'proto.stailer_external_admin.UpdateOrder.UpdateProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder.AddProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder.AddProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.AddProduct.displayName = 'proto.stailer_external_admin.UpdateOrder.AddProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder.FixDeliveryFee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.displayName = 'proto.stailer_external_admin.UpdateOrder.FixDeliveryFee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.UpdateOrder.CalculationResult.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrder.CalculationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrder.CalculationResult.displayName = 'proto.stailer_external_admin.UpdateOrder.CalculationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderToUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderToUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderToUpdateRequest.displayName = 'proto.stailer_external_admin.GetOrderToUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderToUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.GetOrderToUpdateResponse.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderToUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderToUpdateResponse.displayName = 'proto.stailer_external_admin.GetOrderToUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.displayName = 'proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.displayName = 'proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.CalculateToUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.CalculateToUpdateRequest.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.CalculateToUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.CalculateToUpdateRequest.displayName = 'proto.stailer_external_admin.CalculateToUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.CalculateToUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.CalculateToUpdateResponse.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.CalculateToUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.CalculateToUpdateResponse.displayName = 'proto.stailer_external_admin.CalculateToUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.UpdateOrderRequest.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderRequest.displayName = 'proto.stailer_external_admin.UpdateOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderResponse.displayName = 'proto.stailer_external_admin.UpdateOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderResponse.Success = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderResponse.Success, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderResponse.Success.displayName = 'proto.stailer_external_admin.UpdateOrderResponse.Success';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.displayName = 'proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.displayName = 'proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.displayName = 'proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsPeriod.displayName = 'proto.stailer_external_admin.SearchOrderProductsPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsDeliveryTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsDeliveryTime.displayName = 'proto.stailer_external_admin.SearchOrderProductsDeliveryTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.SearchOrderProductsStreamRequest.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsStreamRequest.displayName = 'proto.stailer_external_admin.SearchOrderProductsStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.SearchOrderProductsStreamResponse.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsStreamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsStreamResponse.displayName = 'proto.stailer_external_admin.SearchOrderProductsStreamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.displayName = 'proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.SearchOrderProductsRequest.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsRequest.displayName = 'proto.stailer_external_admin.SearchOrderProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.SearchOrderProductsResponse.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsResponse.displayName = 'proto.stailer_external_admin.SearchOrderProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsResponse.Result, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsResponse.Result.displayName = 'proto.stailer_external_admin.SearchOrderProductsResponse.Result';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.repeatedFields_, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.displayName = 'proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.displayName = 'proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.oneofGroups_);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.displayName = 'proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.displayName = 'proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of GetOrderRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderRequest}
 */
proto.stailer_external_admin.GetOrderRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderRequest}
 */
proto.stailer_external_admin.GetOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderRequest;
  return proto.stailer_external_admin.GetOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderRequest}
 */
proto.stailer_external_admin.GetOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.GetOrderRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.GetOrderRequest} returns this
 */
proto.stailer_external_admin.GetOrderRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    order: (f = msg.getOrder()) && type_order_pb.Order.toObject(includeInstance, f),
    versionTimestamp: (f = msg.getVersionTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of GetOrderResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.order;

  /** @type {?|undefined} */
  this.versionTimestamp;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderResponse}
 */
proto.stailer_external_admin.GetOrderResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderResponse();
  obj.order && jspb.Message.setWrapperField(
      msg, 1, type_order_pb.Order.fromObject(obj.order));
  obj.versionTimestamp && jspb.Message.setWrapperField(
      msg, 2, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.versionTimestamp));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderResponse}
 */
proto.stailer_external_admin.GetOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderResponse;
  return proto.stailer_external_admin.GetOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderResponse}
 */
proto.stailer_external_admin.GetOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_order_pb.Order;
      reader.readMessage(value,type_order_pb.Order.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setVersionTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      type_order_pb.Order.serializeBinaryToWriter
    );
  }
  f = message.getVersionTimestamp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional type.Order order = 1;
 * @return {?proto.type.Order}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.getOrder = function() {
  return /** @type{?proto.type.Order} */ (
    jspb.Message.getWrapperField(this, type_order_pb.Order, 1));
};


/**
 * @param {?proto.type.Order|undefined} value
 * @return {!proto.stailer_external_admin.GetOrderResponse} returns this
*/
proto.stailer_external_admin.GetOrderResponse.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.GetOrderResponse} returns this
 */
proto.stailer_external_admin.GetOrderResponse.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp version_timestamp = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.getVersionTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.GetOrderResponse} returns this
*/
proto.stailer_external_admin.GetOrderResponse.prototype.setVersionTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.GetOrderResponse} returns this
 */
proto.stailer_external_admin.GetOrderResponse.prototype.clearVersionTimestamp = function() {
  return this.setVersionTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderResponse.prototype.hasVersionTimestamp = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cursor: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderUsersRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderUsersRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.phoneNumber;

  /** @type {?|undefined} */
  this.limit;

  /** @type {?|undefined} */
  this.cursor;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderUsersRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderUsersRequest();
  obj.phoneNumber != null && jspb.Message.setField(msg, 1, obj.phoneNumber);
  obj.limit != null && jspb.Message.setField(msg, 2, obj.limit);
  obj.cursor != null && jspb.Message.setField(msg, 3, obj.cursor);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderUsersRequest;
  return proto.stailer_external_admin.SearchOrderUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string phone_number = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest} returns this
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest} returns this
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string cursor = 3;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersRequest} returns this
 */
proto.stailer_external_admin.SearchOrderUsersRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.SearchOrderUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userInfosList: jspb.Message.toObjectList(msg.getUserInfosList(),
    proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.toObject, includeInstance),
    cursor: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderUsersResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderUsersResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.userInfosList;

  /** @type {?|undefined} */
  this.cursor;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderUsersResponse();
  obj.userInfosList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.userInfosList.map(
          proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.fromObject));
  obj.cursor != null && jspb.Message.setField(msg, 3, obj.cursor);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderUsersResponse;
  return proto.stailer_external_admin.SearchOrderUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.deserializeBinaryFromReader);
      msg.addUserInfos(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UserInfo as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.userId;

  /** @type {?|undefined} */
  this.name;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo();
  obj.userId != null && jspb.Message.setField(msg, 1, obj.userId);
  obj.name != null && jspb.Message.setField(msg, 2, obj.name);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo;
  return proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo} returns this
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo} returns this
 */
proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated UserInfo user_infos = 1;
 * @return {!Array<!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo>}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.getUserInfosList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo>} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse} returns this
*/
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.setUserInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.addUserInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.SearchOrderUsersResponse.UserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse} returns this
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.clearUserInfosList = function() {
  return this.setUserInfosList([]);
};


/**
 * optional string cursor = 3;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderUsersResponse} returns this
 */
proto.stailer_external_admin.SearchOrderUsersResponse.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.SearchOrdersRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrdersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deliveryTimeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    familyName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    orderStatusesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    enablePagination: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    view: jspb.Message.getFieldWithDefault(msg, 10, 0),
    receiveMethod: jspb.Message.getFieldWithDefault(msg, 12, 0),
    namePhoneSearchScope: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrdersRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrdersRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.cursor;

  /** @type {?|undefined} */
  this.deliveryTimeId;

  /** @type {?|undefined} */
  this.phoneNumber;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.firstName;

  /** @type {?|undefined} */
  this.familyName;

  /** @type {?|undefined} */
  this.orderStatusesList;

  /** @type {?|undefined} */
  this.date;

  /** @type {?|undefined} */
  this.enablePagination;

  /** @type {?|undefined} */
  this.view;

  /** @type {?|undefined} */
  this.receiveMethod;

  /** @type {?|undefined} */
  this.namePhoneSearchScope;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrdersRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrdersRequest}
 */
proto.stailer_external_admin.SearchOrdersRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrdersRequest();
  obj.cursor != null && jspb.Message.setField(msg, 1, obj.cursor);
  obj.deliveryTimeId != null && jspb.Message.setField(msg, 2, obj.deliveryTimeId);
  obj.phoneNumber != null && jspb.Message.setField(msg, 3, obj.phoneNumber);
  obj.shopId != null && jspb.Message.setField(msg, 4, obj.shopId);
  obj.firstName != null && jspb.Message.setField(msg, 5, obj.firstName);
  obj.familyName != null && jspb.Message.setField(msg, 6, obj.familyName);
  obj.orderStatusesList != null && jspb.Message.setField(msg, 7, obj.orderStatusesList);
  obj.date && jspb.Message.setWrapperField(
      msg, 8, google_type_date_pb.Date.fromObject(obj.date));
  obj.enablePagination != null && jspb.Message.setField(msg, 9, obj.enablePagination);
  obj.view != null && jspb.Message.setField(msg, 10, obj.view);
  obj.receiveMethod != null && jspb.Message.setField(msg, 12, obj.receiveMethod);
  obj.namePhoneSearchScope != null && jspb.Message.setField(msg, 13, obj.namePhoneSearchScope);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrdersRequest}
 */
proto.stailer_external_admin.SearchOrdersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrdersRequest;
  return proto.stailer_external_admin.SearchOrdersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrdersRequest}
 */
proto.stailer_external_admin.SearchOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryTimeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyName(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.type.Order.Status>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderStatuses(values[i]);
      }
      break;
    case 8:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePagination(value);
      break;
    case 10:
      var value = /** @type {!proto.stailer_external_admin.SearchOrdersRequest.View} */ (reader.readEnum());
      msg.setView(value);
      break;
    case 12:
      var value = /** @type {!proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod} */ (reader.readEnum());
      msg.setReceiveMethod(value);
      break;
    case 13:
      var value = /** @type {!proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope} */ (reader.readEnum());
      msg.setNamePhoneSearchScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrdersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeliveryTimeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFamilyName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEnablePagination();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getView();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getReceiveMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getNamePhoneSearchScope();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrdersRequest.View = {
  ORDER: 0,
  ORDER_SUMMARY: 1
};

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod = {
  RECEIVE_METHOD_UNSPECIFIED: 0,
  DELIVERY: 1,
  PICKUP_SHOP: 2,
  PICKUP_CAR: 3,
  PICKUP_LOCKER: 4,
  PICKUP_OTHER_SHOP: 5,
  DELIVERY_UNATTENDED: 6
};

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope = {
  NAME_PHONE_SEARCH_SCOPE_UNSPECIFIED: 0,
  ORDERER_INFO_AND_SHIPPING_INFO: 1
};

/**
 * optional string cursor = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string delivery_time_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getDeliveryTimeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setDeliveryTimeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone_number = 3;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string shop_id = 4;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string first_name = 5;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string family_name = 6;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getFamilyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setFamilyName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated type.Order.Status order_statuses = 7;
 * @return {!Array<!proto.type.Order.Status>}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getOrderStatusesList = function() {
  return /** @type {!Array<!proto.type.Order.Status>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.type.Order.Status>} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setOrderStatusesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.type.Order.Status} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.addOrderStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.clearOrderStatusesList = function() {
  return this.setOrderStatusesList([]);
};


/**
 * optional google.type.Date date = 8;
 * @return {?proto.google.type.Date}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 8));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
*/
proto.stailer_external_admin.SearchOrdersRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool enable_pagination = 9;
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getEnablePagination = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setEnablePagination = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional View view = 10;
 * @return {!proto.stailer_external_admin.SearchOrdersRequest.View}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getView = function() {
  return /** @type {!proto.stailer_external_admin.SearchOrdersRequest.View} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.stailer_external_admin.SearchOrdersRequest.View} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setView = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional ReceiveMethod receive_method = 12;
 * @return {!proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getReceiveMethod = function() {
  return /** @type {!proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.stailer_external_admin.SearchOrdersRequest.ReceiveMethod} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setReceiveMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional NamePhoneSearchScope name_phone_search_scope = 13;
 * @return {!proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope}
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.getNamePhoneSearchScope = function() {
  return /** @type {!proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.stailer_external_admin.SearchOrdersRequest.NamePhoneSearchScope} value
 * @return {!proto.stailer_external_admin.SearchOrdersRequest} returns this
 */
proto.stailer_external_admin.SearchOrdersRequest.prototype.setNamePhoneSearchScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.SearchOrdersResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrdersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    type_order_pb.Order.toObject, includeInstance),
    orderSummariesList: jspb.Message.toObjectList(msg.getOrderSummariesList(),
    proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrdersResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrdersResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.cursor;

  /** @type {?|undefined} */
  this.ordersList;

  /** @type {?|undefined} */
  this.orderSummariesList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse}
 */
proto.stailer_external_admin.SearchOrdersResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrdersResponse();
  obj.cursor != null && jspb.Message.setField(msg, 1, obj.cursor);
  obj.ordersList && jspb.Message.setRepeatedWrapperField(
      msg, 2, obj.ordersList.map(
          type_order_pb.Order.fromObject));
  obj.orderSummariesList && jspb.Message.setRepeatedWrapperField(
      msg, 3, obj.orderSummariesList.map(
          proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse}
 */
proto.stailer_external_admin.SearchOrdersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrdersResponse;
  return proto.stailer_external_admin.SearchOrdersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse}
 */
proto.stailer_external_admin.SearchOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 2:
      var value = new type_order_pb.Order;
      reader.readMessage(value,type_order_pb.Order.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.SearchOrdersResponse.OrderSummary;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.deserializeBinaryFromReader);
      msg.addOrderSummaries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      type_order_pb.Order.serializeBinaryToWriter
    );
  }
  f = message.getOrderSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deliveryFrom: (f = msg.getDeliveryFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deliveryTo: (f = msg.getDeliveryTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    shippingInfo: (f = msg.getShippingInfo()) && type_shipping_info_pb.ShippingInfo.toObject(includeInstance, f),
    ordererInfo: (f = msg.getOrdererInfo()) && type_orderer_info_pb.OrdererInfo.toObject(includeInstance, f),
    chargeAmount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    deliveryOnHoldReason: jspb.Message.getFieldWithDefault(msg, 9, 0),
    nonContactDelivery: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    requirePaperReceipt: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    userRequest: jspb.Message.getFieldWithDefault(msg, 12, ""),
    isChangedDeliveryTimeByStaff: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    productAmount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    receiveMethod: (f = msg.getReceiveMethod()) && type_order_receive_method_pb.OrderReceiveMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderSummary as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;

  /** @type {?|undefined} */
  this.deliveryFrom;

  /** @type {?|undefined} */
  this.deliveryTo;

  /** @type {?|undefined} */
  this.status;

  /** @type {?|undefined} */
  this.shippingInfo;

  /** @type {?|undefined} */
  this.ordererInfo;

  /** @type {?|undefined} */
  this.chargeAmount;

  /** @type {?|undefined} */
  this.deliveryOnHoldReason;

  /** @type {?|undefined} */
  this.nonContactDelivery;

  /** @type {?|undefined} */
  this.requirePaperReceipt;

  /** @type {?|undefined} */
  this.userRequest;

  /** @type {?|undefined} */
  this.isChangedDeliveryTimeByStaff;

  /** @type {?|undefined} */
  this.productAmount;

  /** @type {?|undefined} */
  this.receiveMethod;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrdersResponse.OrderSummary();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  obj.deliveryFrom && jspb.Message.setWrapperField(
      msg, 2, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryFrom));
  obj.deliveryTo && jspb.Message.setWrapperField(
      msg, 3, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryTo));
  obj.status != null && jspb.Message.setField(msg, 4, obj.status);
  obj.shippingInfo && jspb.Message.setWrapperField(
      msg, 6, type_shipping_info_pb.ShippingInfo.fromObject(obj.shippingInfo));
  obj.ordererInfo && jspb.Message.setWrapperField(
      msg, 7, type_orderer_info_pb.OrdererInfo.fromObject(obj.ordererInfo));
  obj.chargeAmount != null && jspb.Message.setField(msg, 8, obj.chargeAmount);
  obj.deliveryOnHoldReason != null && jspb.Message.setField(msg, 9, obj.deliveryOnHoldReason);
  obj.nonContactDelivery != null && jspb.Message.setField(msg, 10, obj.nonContactDelivery);
  obj.requirePaperReceipt != null && jspb.Message.setField(msg, 11, obj.requirePaperReceipt);
  obj.userRequest != null && jspb.Message.setField(msg, 12, obj.userRequest);
  obj.isChangedDeliveryTimeByStaff != null && jspb.Message.setField(msg, 13, obj.isChangedDeliveryTimeByStaff);
  obj.productAmount != null && jspb.Message.setField(msg, 14, obj.productAmount);
  obj.receiveMethod && jspb.Message.setWrapperField(
      msg, 15, type_order_receive_method_pb.OrderReceiveMethod.fromObject(obj.receiveMethod));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrdersResponse.OrderSummary;
  return proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryFrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryTo(value);
      break;
    case 4:
      var value = /** @type {!proto.type.Order.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = new type_shipping_info_pb.ShippingInfo;
      reader.readMessage(value,type_shipping_info_pb.ShippingInfo.deserializeBinaryFromReader);
      msg.setShippingInfo(value);
      break;
    case 7:
      var value = new type_orderer_info_pb.OrdererInfo;
      reader.readMessage(value,type_orderer_info_pb.OrdererInfo.deserializeBinaryFromReader);
      msg.setOrdererInfo(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChargeAmount(value);
      break;
    case 9:
      var value = /** @type {!proto.type.Order.DeliveryOnHoldReason} */ (reader.readEnum());
      msg.setDeliveryOnHoldReason(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNonContactDelivery(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequirePaperReceipt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRequest(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsChangedDeliveryTimeByStaff(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProductAmount(value);
      break;
    case 15:
      var value = new type_order_receive_method_pb.OrderReceiveMethod;
      reader.readMessage(value,type_order_receive_method_pb.OrderReceiveMethod.deserializeBinaryFromReader);
      msg.setReceiveMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeliveryFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getShippingInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      type_shipping_info_pb.ShippingInfo.serializeBinaryToWriter
    );
  }
  f = message.getOrdererInfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      type_orderer_info_pb.OrdererInfo.serializeBinaryToWriter
    );
  }
  f = message.getChargeAmount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDeliveryOnHoldReason();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getNonContactDelivery();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getRequirePaperReceipt();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getUserRequest();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIsChangedDeliveryTimeByStaff();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getProductAmount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getReceiveMethod();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      type_order_receive_method_pb.OrderReceiveMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp delivery_from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getDeliveryFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setDeliveryFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.clearDeliveryFrom = function() {
  return this.setDeliveryFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.hasDeliveryFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp delivery_to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getDeliveryTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setDeliveryTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.clearDeliveryTo = function() {
  return this.setDeliveryTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.hasDeliveryTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional type.Order.Status status = 4;
 * @return {!proto.type.Order.Status}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getStatus = function() {
  return /** @type {!proto.type.Order.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.type.Order.Status} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional type.ShippingInfo shipping_info = 6;
 * @return {?proto.type.ShippingInfo}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getShippingInfo = function() {
  return /** @type{?proto.type.ShippingInfo} */ (
    jspb.Message.getWrapperField(this, type_shipping_info_pb.ShippingInfo, 6));
};


/**
 * @param {?proto.type.ShippingInfo|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setShippingInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.clearShippingInfo = function() {
  return this.setShippingInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.hasShippingInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional type.OrdererInfo orderer_info = 7;
 * @return {?proto.type.OrdererInfo}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getOrdererInfo = function() {
  return /** @type{?proto.type.OrdererInfo} */ (
    jspb.Message.getWrapperField(this, type_orderer_info_pb.OrdererInfo, 7));
};


/**
 * @param {?proto.type.OrdererInfo|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setOrdererInfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.clearOrdererInfo = function() {
  return this.setOrdererInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.hasOrdererInfo = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 charge_amount = 8;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getChargeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setChargeAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional type.Order.DeliveryOnHoldReason delivery_on_hold_reason = 9;
 * @return {!proto.type.Order.DeliveryOnHoldReason}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getDeliveryOnHoldReason = function() {
  return /** @type {!proto.type.Order.DeliveryOnHoldReason} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.type.Order.DeliveryOnHoldReason} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setDeliveryOnHoldReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional bool non_contact_delivery = 10;
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getNonContactDelivery = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setNonContactDelivery = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool require_paper_receipt = 11;
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getRequirePaperReceipt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setRequirePaperReceipt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string user_request = 12;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getUserRequest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setUserRequest = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool is_changed_delivery_time_by_staff = 13;
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getIsChangedDeliveryTimeByStaff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setIsChangedDeliveryTimeByStaff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional int64 product_amount = 14;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getProductAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setProductAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional type.OrderReceiveMethod receive_method = 15;
 * @return {?proto.type.OrderReceiveMethod}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.getReceiveMethod = function() {
  return /** @type{?proto.type.OrderReceiveMethod} */ (
    jspb.Message.getWrapperField(this, type_order_receive_method_pb.OrderReceiveMethod, 15));
};


/**
 * @param {?proto.type.OrderReceiveMethod|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.setReceiveMethod = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.clearReceiveMethod = function() {
  return this.setReceiveMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrdersResponse.OrderSummary.prototype.hasReceiveMethod = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string cursor = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated type.Order orders = 2;
 * @return {!Array<!proto.type.Order>}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.type.Order>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_order_pb.Order, 2));
};


/**
 * @param {!Array<!proto.type.Order>} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.type.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.Order}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.type.Order, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};


/**
 * repeated OrderSummary order_summaries = 3;
 * @return {!Array<!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary>}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.getOrderSummariesList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.SearchOrdersResponse.OrderSummary, 3));
};


/**
 * @param {!Array<!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary>} value
 * @return {!proto.stailer_external_admin.SearchOrdersResponse} returns this
*/
proto.stailer_external_admin.SearchOrdersResponse.prototype.setOrderSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.SearchOrdersResponse.OrderSummary}
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.addOrderSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.stailer_external_admin.SearchOrdersResponse.OrderSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrdersResponse} returns this
 */
proto.stailer_external_admin.SearchOrdersResponse.prototype.clearOrderSummariesList = function() {
  return this.setOrderSummariesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deliveryTimeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bundleRuleSnapshotIdsToRemoveList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    acknowledgedDroppedCampaignsList: jspb.Message.toObjectList(msg.getAcknowledgedDroppedCampaignsList(),
    proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ChangeDeliveryTimeRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;

  /** @type {?|undefined} */
  this.deliveryTimeId;

  /** @type {?|undefined} */
  this.bundleRuleSnapshotIdsToRemoveList;

  /** @type {?|undefined} */
  this.acknowledgedDroppedCampaignsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  obj.deliveryTimeId != null && jspb.Message.setField(msg, 2, obj.deliveryTimeId);
  obj.bundleRuleSnapshotIdsToRemoveList != null && jspb.Message.setField(msg, 3, obj.bundleRuleSnapshotIdsToRemoveList);
  obj.acknowledgedDroppedCampaignsList && jspb.Message.setRepeatedWrapperField(
      msg, 4, obj.acknowledgedDroppedCampaignsList.map(
          proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeRequest;
  return proto.stailer_external_admin.ChangeDeliveryTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryTimeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addBundleRuleSnapshotIdsToRemove(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.deserializeBinaryFromReader);
      msg.addAcknowledgedDroppedCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeliveryTimeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBundleRuleSnapshotIdsToRemoveList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getAcknowledgedDroppedCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ruleId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AcknowledgedDroppedCampaign as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.campaignId;

  /** @type {?|undefined} */
  this.ruleId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign();
  obj.campaignId != null && jspb.Message.setField(msg, 1, obj.campaignId);
  obj.ruleId != null && jspb.Message.setField(msg, 2, obj.ruleId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign;
  return proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRuleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRuleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rule_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.getRuleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign.prototype.setRuleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string delivery_time_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.getDeliveryTimeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.setDeliveryTimeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string bundle_rule_snapshot_ids_to_remove = 3;
 * @return {!Array<string>}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.getBundleRuleSnapshotIdsToRemoveList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.setBundleRuleSnapshotIdsToRemoveList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.addBundleRuleSnapshotIdsToRemove = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.clearBundleRuleSnapshotIdsToRemoveList = function() {
  return this.setBundleRuleSnapshotIdsToRemoveList([]);
};


/**
 * repeated AcknowledgedDroppedCampaign acknowledged_dropped_campaigns = 4;
 * @return {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign>}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.getAcknowledgedDroppedCampaignsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign, 4));
};


/**
 * @param {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign>} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.setAcknowledgedDroppedCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.addAcknowledgedDroppedCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.stailer_external_admin.ChangeDeliveryTimeRequest.AcknowledgedDroppedCampaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeRequest} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeRequest.prototype.clearAcknowledgedDroppedCampaignsList = function() {
  return this.setAcknowledgedDroppedCampaignsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1,
  FAILURE: 2
};

/**
 * @return {proto.stailer_external_admin.ChangeDeliveryTimeResponse.ResultCase}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.getResultCase = function() {
  return /** @type {proto.stailer_external_admin.ChangeDeliveryTimeResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.toObject(includeInstance, f),
    failure: (f = msg.getFailure()) && proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ChangeDeliveryTimeResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.success;

  /** @type {?|undefined} */
  this.failure;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse();
  obj.success && jspb.Message.setWrapperField(
      msg, 1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.fromObject(obj.success));
  obj.failure && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.fromObject(obj.failure));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.deserializeBinaryFromReader);
      msg.setFailure(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.serializeBinaryToWriter
    );
  }
  f = message.getFailure();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Success as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ReasonCase = {
  REASON_NOT_SET: 0,
  BUNDLE_RULE_EXPIRED: 1,
  CAMPAIGN_EXPIRED: 2
};

/**
 * @return {proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ReasonCase}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.getReasonCase = function() {
  return /** @type {proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ReasonCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleRuleExpired: (f = msg.getBundleRuleExpired()) && proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.toObject(includeInstance, f),
    campaignExpired: (f = msg.getCampaignExpired()) && proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of FailureDetail as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.bundleRuleExpired;

  /** @type {?|undefined} */
  this.campaignExpired;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail();
  obj.bundleRuleExpired && jspb.Message.setWrapperField(
      msg, 1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.fromObject(obj.bundleRuleExpired));
  obj.campaignExpired && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.fromObject(obj.campaignExpired));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.deserializeBinaryFromReader);
      msg.setBundleRuleExpired(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.deserializeBinaryFromReader);
      msg.setCampaignExpired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleRuleExpired();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.serializeBinaryToWriter
    );
  }
  f = message.getCampaignExpired();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.toObject = function(includeInstance, msg) {
  var f, obj = {
    expiredBundleItemsList: jspb.Message.toObjectList(msg.getExpiredBundleItemsList(),
    type_bundled_item_pb.BundledItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of BundleRuleExpired as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.expiredBundleItemsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired();
  obj.expiredBundleItemsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.expiredBundleItemsList.map(
          type_bundled_item_pb.BundledItem.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_bundled_item_pb.BundledItem;
      reader.readMessage(value,type_bundled_item_pb.BundledItem.deserializeBinaryFromReader);
      msg.addExpiredBundleItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpiredBundleItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      type_bundled_item_pb.BundledItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated type.BundledItem expired_bundle_items = 1;
 * @return {!Array<!proto.type.BundledItem>}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.getExpiredBundleItemsList = function() {
  return /** @type{!Array<!proto.type.BundledItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_bundled_item_pb.BundledItem, 1));
};


/**
 * @param {!Array<!proto.type.BundledItem>} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.setExpiredBundleItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.type.BundledItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.BundledItem}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.addExpiredBundleItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.type.BundledItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired.prototype.clearExpiredBundleItemsList = function() {
  return this.setExpiredBundleItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.toObject = function(includeInstance, msg) {
  var f, obj = {
    droppedCampaignsList: jspb.Message.toObjectList(msg.getDroppedCampaignsList(),
    proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CampaignExpired as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.droppedCampaignsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired();
  obj.droppedCampaignsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.droppedCampaignsList.map(
          proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.deserializeBinaryFromReader);
      msg.addDroppedCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDroppedCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DroppedCampaign dropped_campaigns = 1;
 * @return {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign>}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.getDroppedCampaignsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign>} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.setDroppedCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.addDroppedCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired.prototype.clearDroppedCampaignsList = function() {
  return this.setDroppedCampaignsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ruleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    campaignName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    earnedPoint: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DroppedCampaign as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.campaignId;

  /** @type {?|undefined} */
  this.ruleId;

  /** @type {?|undefined} */
  this.campaignName;

  /** @type {?|undefined} */
  this.earnedPoint;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign();
  obj.campaignId != null && jspb.Message.setField(msg, 1, obj.campaignId);
  obj.ruleId != null && jspb.Message.setField(msg, 2, obj.ruleId);
  obj.campaignName != null && jspb.Message.setField(msg, 3, obj.campaignName);
  obj.earnedPoint != null && jspb.Message.setField(msg, 4, obj.earnedPoint);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRuleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEarnedPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRuleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCampaignName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEarnedPoint();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rule_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.getRuleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.setRuleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string campaign_name = 3;
 * @return {string}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.getCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.setCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 earned_point = 4;
 * @return {number}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.getEarnedPoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.DroppedCampaign.prototype.setEarnedPoint = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional BundleRuleExpired bundle_rule_expired = 1;
 * @return {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.getBundleRuleExpired = function() {
  return /** @type{?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired, 1));
};


/**
 * @param {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.BundleRuleExpired|undefined} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.setBundleRuleExpired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.clearBundleRuleExpired = function() {
  return this.setBundleRuleExpired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.hasBundleRuleExpired = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CampaignExpired campaign_expired = 2;
 * @return {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.getCampaignExpired = function() {
  return /** @type{?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired, 2));
};


/**
 * @param {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.CampaignExpired|undefined} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.setCampaignExpired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.clearCampaignExpired = function() {
  return this.setCampaignExpired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.prototype.hasCampaignExpired = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.toObject = function(includeInstance, msg) {
  var f, obj = {
    failureDetailsList: jspb.Message.toObjectList(msg.getFailureDetailsList(),
    proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Failure as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.failureDetailsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure();
  obj.failureDetailsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.failureDetailsList.map(
          proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure;
  return proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail;
      reader.readMessage(value,proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.deserializeBinaryFromReader);
      msg.addFailureDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailureDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FailureDetail failure_details = 1;
 * @return {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail>}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.getFailureDetailsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail>} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.setFailureDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.addFailureDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.ChangeDeliveryTimeResponse.FailureDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure.prototype.clearFailureDetailsList = function() {
  return this.setFailureDetailsList([]);
};


/**
 * optional Success success = 1;
 * @return {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.getSuccess = function() {
  return /** @type{?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success, 1));
};


/**
 * @param {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Success|undefined} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.stailer_external_admin.ChangeDeliveryTimeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Failure failure = 2;
 * @return {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.getFailure = function() {
  return /** @type{?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure, 2));
};


/**
 * @param {?proto.stailer_external_admin.ChangeDeliveryTimeResponse.Failure|undefined} value
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} returns this
*/
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.setFailure = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.stailer_external_admin.ChangeDeliveryTimeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.ChangeDeliveryTimeResponse} returns this
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.clearFailure = function() {
  return this.setFailure(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.ChangeDeliveryTimeResponse.prototype.hasFailure = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.CancelOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.CancelOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.CancelOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CancelOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CancelOrderRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.CancelOrderRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.CancelOrderRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.CancelOrderRequest}
 */
proto.stailer_external_admin.CancelOrderRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.CancelOrderRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.CancelOrderRequest}
 */
proto.stailer_external_admin.CancelOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.CancelOrderRequest;
  return proto.stailer_external_admin.CancelOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.CancelOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.CancelOrderRequest}
 */
proto.stailer_external_admin.CancelOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.CancelOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.CancelOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.CancelOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CancelOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.CancelOrderRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.CancelOrderRequest} returns this
 */
proto.stailer_external_admin.CancelOrderRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.CancelOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.CancelOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.CancelOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CancelOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CancelOrderResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.CancelOrderResponse.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.CancelOrderResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.CancelOrderResponse}
 */
proto.stailer_external_admin.CancelOrderResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.CancelOrderResponse();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.CancelOrderResponse}
 */
proto.stailer_external_admin.CancelOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.CancelOrderResponse;
  return proto.stailer_external_admin.CancelOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.CancelOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.CancelOrderResponse}
 */
proto.stailer_external_admin.CancelOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.CancelOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.CancelOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.CancelOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CancelOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UpdateOrder as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder}
 */
proto.stailer_external_admin.UpdateOrder.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder}
 */
proto.stailer_external_admin.UpdateOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder;
  return proto.stailer_external_admin.UpdateOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder}
 */
proto.stailer_external_admin.UpdateOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.stailer_external_admin.UpdateOrder.DisableUpdateReason = {
  UNKNOWN: 0,
  FINALIZE_JOB_STARTED: 1,
  DURING_POINT_SERVER_MAINTENANCE: 2,
  INVOICE_FINALIZED: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: jspb.Message.getFieldWithDefault(msg, 2, 0),
    priceType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    janCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    containerType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    id: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CustomProduct as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.name;

  /** @type {?|undefined} */
  this.price;

  /** @type {?|undefined} */
  this.priceType;

  /** @type {?|undefined} */
  this.janCode;

  /** @type {?|undefined} */
  this.amount;

  /** @type {?|undefined} */
  this.containerType;

  /** @type {?|undefined} */
  this.id;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder.CustomProduct();
  obj.name != null && jspb.Message.setField(msg, 1, obj.name);
  obj.price != null && jspb.Message.setField(msg, 2, obj.price);
  obj.priceType != null && jspb.Message.setField(msg, 3, obj.priceType);
  obj.janCode != null && jspb.Message.setField(msg, 4, obj.janCode);
  obj.amount != null && jspb.Message.setField(msg, 5, obj.amount);
  obj.containerType != null && jspb.Message.setField(msg, 6, obj.containerType);
  obj.id != null && jspb.Message.setField(msg, 7, obj.id);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
  return proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {!proto.type.PriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJanCode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {!proto.type.ContainerType} */ (reader.readEnum());
      msg.setContainerType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getJanCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getContainerType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 price = 2;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional type.PriceType price_type = 3;
 * @return {!proto.type.PriceType}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getPriceType = function() {
  return /** @type {!proto.type.PriceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.type.PriceType} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string jan_code = 4;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getJanCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setJanCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 amount = 5;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional type.ContainerType container_type = 6;
 * @return {!proto.type.ContainerType}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getContainerType = function() {
  return /** @type {!proto.type.ContainerType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.type.ContainerType} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setContainerType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string id = 7;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.CustomProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.repeatedFields_ = [2,4,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.UpdateProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    statusesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    deprecatedAlternativeProduct: (f = msg.getDeprecatedAlternativeProduct()) && proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject(includeInstance, f),
    alternativeProductsList: jspb.Message.toObjectList(msg.getAlternativeProductsList(),
    proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject, includeInstance),
    price: jspb.Message.getFieldWithDefault(msg, 5, 0),
    assumedStatusesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UpdateProduct as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.statusesList;

  /** @type {?|undefined} */
  this.deprecatedAlternativeProduct;

  /** @type {?|undefined} */
  this.alternativeProductsList;

  /** @type {?|undefined} */
  this.price;

  /** @type {?|undefined} */
  this.assumedStatusesList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder.UpdateProduct();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  obj.statusesList != null && jspb.Message.setField(msg, 2, obj.statusesList);
  obj.deprecatedAlternativeProduct && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject(obj.deprecatedAlternativeProduct));
  obj.alternativeProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 4, obj.alternativeProductsList.map(
          proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject));
  obj.price != null && jspb.Message.setField(msg, 5, obj.price);
  obj.assumedStatusesList != null && jspb.Message.setField(msg, 6, obj.assumedStatusesList);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder.UpdateProduct;
  return proto.stailer_external_admin.UpdateOrder.UpdateProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.type.TransactionProduct.Status>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 3:
      var value = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader);
      msg.setDeprecatedAlternativeProduct(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader);
      msg.addAlternativeProducts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.type.TransactionProduct.Status>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAssumedStatuses(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.UpdateProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getDeprecatedAlternativeProduct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter
    );
  }
  f = message.getAlternativeProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAssumedStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated type.TransactionProduct.Status statuses = 2;
 * @return {!Array<!proto.type.TransactionProduct.Status>}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.type.TransactionProduct.Status>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.type.TransactionProduct.Status>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.type.TransactionProduct.Status} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * optional CustomProduct deprecated_alternative_product = 3;
 * @return {?proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getDeprecatedAlternativeProduct = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.CustomProduct} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.CustomProduct, 3));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.CustomProduct|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
*/
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setDeprecatedAlternativeProduct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.clearDeprecatedAlternativeProduct = function() {
  return this.setDeprecatedAlternativeProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.hasDeprecatedAlternativeProduct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated CustomProduct alternative_products = 4;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getAlternativeProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.CustomProduct, 4));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
*/
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setAlternativeProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.addAlternativeProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.stailer_external_admin.UpdateOrder.CustomProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.clearAlternativeProductsList = function() {
  return this.setAlternativeProductsList([]);
};


/**
 * optional int64 price = 5;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated type.TransactionProduct.Status assumed_statuses = 6;
 * @return {!Array<!proto.type.TransactionProduct.Status>}
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.getAssumedStatusesList = function() {
  return /** @type {!Array<!proto.type.TransactionProduct.Status>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.type.TransactionProduct.Status>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.setAssumedStatusesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.type.TransactionProduct.Status} value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.addAssumedStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.UpdateProduct.prototype.clearAssumedStatusesList = function() {
  return this.setAssumedStatusesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.AddProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    productData: (f = msg.getProductData()) && proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AddProduct as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productData;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder.AddProduct();
  obj.productData && jspb.Message.setWrapperField(
      msg, 1, proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject(obj.productData));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder.AddProduct;
  return proto.stailer_external_admin.UpdateOrder.AddProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader);
      msg.setProductData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.AddProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional CustomProduct product_data = 1;
 * @return {?proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.getProductData = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.CustomProduct} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.CustomProduct, 1));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.CustomProduct|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct} returns this
*/
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.setProductData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct} returns this
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.clearProductData = function() {
  return this.setProductData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrder.AddProduct.prototype.hasProductData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of FixDeliveryFee as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.amount;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder.FixDeliveryFee();
  obj.amount != null && jspb.Message.setField(msg, 1, obj.amount);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder.FixDeliveryFee;
  return proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} returns this
 */
proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.repeatedFields_ = [12,14,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrder.CalculationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrder.CalculationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentAmount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isRedeemedPointChanged: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isDeliveryFeeFixed: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    feesList: jspb.Message.toObjectList(msg.getFeesList(),
    type_order_pb.Order.Fee.toObject, includeInstance),
    preDiscountTotalAmount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    discountsList: jspb.Message.toObjectList(msg.getDiscountsList(),
    type_order_pb.Order.Discount.toObject, includeInstance),
    finalTotalPrice: (f = msg.getFinalTotalPrice()) && type_order_pb.Order.FinalTotalPrice.toObject(includeInstance, f),
    paymentsList: jspb.Message.toObjectList(msg.getPaymentsList(),
    type_order_pb.Order.Payment.toObject, includeInstance),
    productTotalAmount: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CalculationResult as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.paymentAmount;

  /** @type {?|undefined} */
  this.isRedeemedPointChanged;

  /** @type {?|undefined} */
  this.isDeliveryFeeFixed;

  /** @type {?|undefined} */
  this.feesList;

  /** @type {?|undefined} */
  this.preDiscountTotalAmount;

  /** @type {?|undefined} */
  this.discountsList;

  /** @type {?|undefined} */
  this.finalTotalPrice;

  /** @type {?|undefined} */
  this.paymentsList;

  /** @type {?|undefined} */
  this.productTotalAmount;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrder.CalculationResult.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrder.CalculationResult();
  obj.paymentAmount != null && jspb.Message.setField(msg, 7, obj.paymentAmount);
  obj.isRedeemedPointChanged != null && jspb.Message.setField(msg, 9, obj.isRedeemedPointChanged);
  obj.isDeliveryFeeFixed != null && jspb.Message.setField(msg, 10, obj.isDeliveryFeeFixed);
  obj.feesList && jspb.Message.setRepeatedWrapperField(
      msg, 12, obj.feesList.map(
          type_order_pb.Order.Fee.fromObject));
  obj.preDiscountTotalAmount != null && jspb.Message.setField(msg, 13, obj.preDiscountTotalAmount);
  obj.discountsList && jspb.Message.setRepeatedWrapperField(
      msg, 14, obj.discountsList.map(
          type_order_pb.Order.Discount.fromObject));
  obj.finalTotalPrice && jspb.Message.setWrapperField(
      msg, 15, type_order_pb.Order.FinalTotalPrice.fromObject(obj.finalTotalPrice));
  obj.paymentsList && jspb.Message.setRepeatedWrapperField(
      msg, 16, obj.paymentsList.map(
          type_order_pb.Order.Payment.fromObject));
  obj.productTotalAmount != null && jspb.Message.setField(msg, 17, obj.productTotalAmount);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrder.CalculationResult;
  return proto.stailer_external_admin.UpdateOrder.CalculationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrder.CalculationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPaymentAmount(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRedeemedPointChanged(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeliveryFeeFixed(value);
      break;
    case 12:
      var value = new type_order_pb.Order.Fee;
      reader.readMessage(value,type_order_pb.Order.Fee.deserializeBinaryFromReader);
      msg.addFees(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPreDiscountTotalAmount(value);
      break;
    case 14:
      var value = new type_order_pb.Order.Discount;
      reader.readMessage(value,type_order_pb.Order.Discount.deserializeBinaryFromReader);
      msg.addDiscounts(value);
      break;
    case 15:
      var value = new type_order_pb.Order.FinalTotalPrice;
      reader.readMessage(value,type_order_pb.Order.FinalTotalPrice.deserializeBinaryFromReader);
      msg.setFinalTotalPrice(value);
      break;
    case 16:
      var value = new type_order_pb.Order.Payment;
      reader.readMessage(value,type_order_pb.Order.Payment.deserializeBinaryFromReader);
      msg.addPayments(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProductTotalAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrder.CalculationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrder.CalculationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentAmount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getIsRedeemedPointChanged();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsDeliveryFeeFixed();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      type_order_pb.Order.Fee.serializeBinaryToWriter
    );
  }
  f = message.getPreDiscountTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getDiscountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      type_order_pb.Order.Discount.serializeBinaryToWriter
    );
  }
  f = message.getFinalTotalPrice();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      type_order_pb.Order.FinalTotalPrice.serializeBinaryToWriter
    );
  }
  f = message.getPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      type_order_pb.Order.Payment.serializeBinaryToWriter
    );
  }
  f = message.getProductTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
};


/**
 * optional int64 payment_amount = 7;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getPaymentAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setPaymentAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool is_redeemed_point_changed = 9;
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getIsRedeemedPointChanged = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setIsRedeemedPointChanged = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool is_delivery_fee_fixed = 10;
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getIsDeliveryFeeFixed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setIsDeliveryFeeFixed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated type.Order.Fee fees = 12;
 * @return {!Array<!proto.type.Order.Fee>}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getFeesList = function() {
  return /** @type{!Array<!proto.type.Order.Fee>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_order_pb.Order.Fee, 12));
};


/**
 * @param {!Array<!proto.type.Order.Fee>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
*/
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setFeesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.type.Order.Fee=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.Order.Fee}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.addFees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.type.Order.Fee, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};


/**
 * optional int64 pre_discount_total_amount = 13;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getPreDiscountTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setPreDiscountTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated type.Order.Discount discounts = 14;
 * @return {!Array<!proto.type.Order.Discount>}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getDiscountsList = function() {
  return /** @type{!Array<!proto.type.Order.Discount>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_order_pb.Order.Discount, 14));
};


/**
 * @param {!Array<!proto.type.Order.Discount>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
*/
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setDiscountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.type.Order.Discount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.Order.Discount}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.addDiscounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.type.Order.Discount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.clearDiscountsList = function() {
  return this.setDiscountsList([]);
};


/**
 * optional type.Order.FinalTotalPrice final_total_price = 15;
 * @return {?proto.type.Order.FinalTotalPrice}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getFinalTotalPrice = function() {
  return /** @type{?proto.type.Order.FinalTotalPrice} */ (
    jspb.Message.getWrapperField(this, type_order_pb.Order.FinalTotalPrice, 15));
};


/**
 * @param {?proto.type.Order.FinalTotalPrice|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
*/
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setFinalTotalPrice = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.clearFinalTotalPrice = function() {
  return this.setFinalTotalPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.hasFinalTotalPrice = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated type.Order.Payment payments = 16;
 * @return {!Array<!proto.type.Order.Payment>}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getPaymentsList = function() {
  return /** @type{!Array<!proto.type.Order.Payment>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_order_pb.Order.Payment, 16));
};


/**
 * @param {!Array<!proto.type.Order.Payment>} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
*/
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.type.Order.Payment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.Order.Payment}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.addPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.type.Order.Payment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.clearPaymentsList = function() {
  return this.setPaymentsList([]);
};


/**
 * optional int64 product_total_amount = 17;
 * @return {number}
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.getProductTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.UpdateOrder.CalculationResult} returns this
 */
proto.stailer_external_admin.UpdateOrder.CalculationResult.prototype.setProductTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderToUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderToUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of GetOrderToUpdateRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateRequest}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderToUpdateRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateRequest}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderToUpdateRequest;
  return proto.stailer_external_admin.GetOrderToUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateRequest}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderToUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateRequest} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderToUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    productLineItemsList: jspb.Message.toObjectList(msg.getProductLineItemsList(),
    proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.toObject, includeInstance),
    calculationResult: (f = msg.getCalculationResult()) && proto.stailer_external_admin.UpdateOrder.CalculationResult.toObject(includeInstance, f),
    disableUpdate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isProductPrepared: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    disableUpdateReason: jspb.Message.getFieldWithDefault(msg, 5, 0),
    isDeterminedContainers: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isDeliveryFeeFixed: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of GetOrderToUpdateResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productLineItemsList;

  /** @type {?|undefined} */
  this.calculationResult;

  /** @type {?|undefined} */
  this.disableUpdate;

  /** @type {?|undefined} */
  this.isProductPrepared;

  /** @type {?|undefined} */
  this.disableUpdateReason;

  /** @type {?|undefined} */
  this.isDeterminedContainers;

  /** @type {?|undefined} */
  this.isDeliveryFeeFixed;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse();
  obj.productLineItemsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.productLineItemsList.map(
          proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.fromObject));
  obj.calculationResult && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.UpdateOrder.CalculationResult.fromObject(obj.calculationResult));
  obj.disableUpdate != null && jspb.Message.setField(msg, 3, obj.disableUpdate);
  obj.isProductPrepared != null && jspb.Message.setField(msg, 4, obj.isProductPrepared);
  obj.disableUpdateReason != null && jspb.Message.setField(msg, 5, obj.disableUpdateReason);
  obj.isDeterminedContainers != null && jspb.Message.setField(msg, 6, obj.isDeterminedContainers);
  obj.isDeliveryFeeFixed != null && jspb.Message.setField(msg, 7, obj.isDeliveryFeeFixed);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse;
  return proto.stailer_external_admin.GetOrderToUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem;
      reader.readMessage(value,proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.deserializeBinaryFromReader);
      msg.addProductLineItems(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.UpdateOrder.CalculationResult;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CalculationResult.deserializeBinaryFromReader);
      msg.setCalculationResult(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableUpdate(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsProductPrepared(value);
      break;
    case 5:
      var value = /** @type {!proto.stailer_external_admin.UpdateOrder.DisableUpdateReason} */ (reader.readEnum());
      msg.setDisableUpdateReason(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeterminedContainers(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeliveryFeeFixed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderToUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductLineItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.serializeBinaryToWriter
    );
  }
  f = message.getCalculationResult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.UpdateOrder.CalculationResult.serializeBinaryToWriter
    );
  }
  f = message.getDisableUpdate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsProductPrepared();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getDisableUpdateReason();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIsDeterminedContainers();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsDeliveryFeeFixed();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    originalProduct: (f = msg.getOriginalProduct()) && type_transaction_product_pb.TransactionProduct.toObject(includeInstance, f),
    deprecatedAlternativeProduct: (f = msg.getDeprecatedAlternativeProduct()) && proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject(includeInstance, f),
    alternativeProductsList: jspb.Message.toObjectList(msg.getAlternativeProductsList(),
    proto.stailer_external_admin.UpdateOrder.CustomProduct.toObject, includeInstance),
    appliedPointCampaignsList: jspb.Message.toObjectList(msg.getAppliedPointCampaignsList(),
    proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ProductLineItem as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.originalProduct;

  /** @type {?|undefined} */
  this.deprecatedAlternativeProduct;

  /** @type {?|undefined} */
  this.alternativeProductsList;

  /** @type {?|undefined} */
  this.appliedPointCampaignsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem();
  obj.originalProduct && jspb.Message.setWrapperField(
      msg, 1, type_transaction_product_pb.TransactionProduct.fromObject(obj.originalProduct));
  obj.deprecatedAlternativeProduct && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject(obj.deprecatedAlternativeProduct));
  obj.alternativeProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 3, obj.alternativeProductsList.map(
          proto.stailer_external_admin.UpdateOrder.CustomProduct.fromObject));
  obj.appliedPointCampaignsList && jspb.Message.setRepeatedWrapperField(
      msg, 4, obj.appliedPointCampaignsList.map(
          proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem;
  return proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_transaction_product_pb.TransactionProduct;
      reader.readMessage(value,type_transaction_product_pb.TransactionProduct.deserializeBinaryFromReader);
      msg.setOriginalProduct(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader);
      msg.setDeprecatedAlternativeProduct(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.UpdateOrder.CustomProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CustomProduct.deserializeBinaryFromReader);
      msg.addAlternativeProducts(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign;
      reader.readMessage(value,proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.deserializeBinaryFromReader);
      msg.addAppliedPointCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOriginalProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      type_transaction_product_pb.TransactionProduct.serializeBinaryToWriter
    );
  }
  f = message.getDeprecatedAlternativeProduct();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter
    );
  }
  f = message.getAlternativeProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.stailer_external_admin.UpdateOrder.CustomProduct.serializeBinaryToWriter
    );
  }
  f = message.getAppliedPointCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    pointCampaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AppliedPointCampaign as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.pointCampaignId;

  /** @type {?|undefined} */
  this.name;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign();
  obj.pointCampaignId != null && jspb.Message.setField(msg, 1, obj.pointCampaignId);
  obj.name != null && jspb.Message.setField(msg, 2, obj.name);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign;
  return proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPointCampaignId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string point_campaign_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.getPointCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.setPointCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional type.TransactionProduct original_product = 1;
 * @return {?proto.type.TransactionProduct}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.getOriginalProduct = function() {
  return /** @type{?proto.type.TransactionProduct} */ (
    jspb.Message.getWrapperField(this, type_transaction_product_pb.TransactionProduct, 1));
};


/**
 * @param {?proto.type.TransactionProduct|undefined} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.setOriginalProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.clearOriginalProduct = function() {
  return this.setOriginalProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.hasOriginalProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UpdateOrder.CustomProduct deprecated_alternative_product = 2;
 * @return {?proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.getDeprecatedAlternativeProduct = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.CustomProduct} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.CustomProduct, 2));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.CustomProduct|undefined} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.setDeprecatedAlternativeProduct = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.clearDeprecatedAlternativeProduct = function() {
  return this.setDeprecatedAlternativeProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.hasDeprecatedAlternativeProduct = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UpdateOrder.CustomProduct alternative_products = 3;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.getAlternativeProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.CustomProduct, 3));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.CustomProduct>} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.setAlternativeProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.CustomProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.CustomProduct}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.addAlternativeProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.stailer_external_admin.UpdateOrder.CustomProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.clearAlternativeProductsList = function() {
  return this.setAlternativeProductsList([]);
};


/**
 * repeated AppliedPointCampaign applied_point_campaigns = 4;
 * @return {!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign>}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.getAppliedPointCampaignsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign, 4));
};


/**
 * @param {!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign>} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.setAppliedPointCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.addAppliedPointCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.AppliedPointCampaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem.prototype.clearAppliedPointCampaignsList = function() {
  return this.setAppliedPointCampaignsList([]);
};


/**
 * repeated ProductLineItem product_line_items = 1;
 * @return {!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem>}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getProductLineItemsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem>} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setProductLineItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.addProductLineItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.GetOrderToUpdateResponse.ProductLineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.clearProductLineItemsList = function() {
  return this.setProductLineItemsList([]);
};


/**
 * optional UpdateOrder.CalculationResult calculation_result = 2;
 * @return {?proto.stailer_external_admin.UpdateOrder.CalculationResult}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getCalculationResult = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.CalculationResult} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.CalculationResult, 2));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.CalculationResult|undefined} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
*/
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setCalculationResult = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.clearCalculationResult = function() {
  return this.setCalculationResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.hasCalculationResult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool disable_update = 3;
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getDisableUpdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setDisableUpdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_product_prepared = 4;
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getIsProductPrepared = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setIsProductPrepared = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional UpdateOrder.DisableUpdateReason disable_update_reason = 5;
 * @return {!proto.stailer_external_admin.UpdateOrder.DisableUpdateReason}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getDisableUpdateReason = function() {
  return /** @type {!proto.stailer_external_admin.UpdateOrder.DisableUpdateReason} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.DisableUpdateReason} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setDisableUpdateReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool is_determined_containers = 6;
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getIsDeterminedContainers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setIsDeterminedContainers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_delivery_fee_fixed = 7;
 * @return {boolean}
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.getIsDeliveryFeeFixed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.GetOrderToUpdateResponse} returns this
 */
proto.stailer_external_admin.GetOrderToUpdateResponse.prototype.setIsDeliveryFeeFixed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.CalculateToUpdateRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.CalculateToUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.CalculateToUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CalculateToUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    addProductsList: jspb.Message.toObjectList(msg.getAddProductsList(),
    proto.stailer_external_admin.UpdateOrder.AddProduct.toObject, includeInstance),
    updateProductsList: jspb.Message.toObjectList(msg.getUpdateProductsList(),
    proto.stailer_external_admin.UpdateOrder.UpdateProduct.toObject, includeInstance),
    skipRecalculationOfDeliveryFee: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    fixDeliveryFee: (f = msg.getFixDeliveryFee()) && proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CalculateToUpdateRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.CalculateToUpdateRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;

  /** @type {?|undefined} */
  this.addProductsList;

  /** @type {?|undefined} */
  this.updateProductsList;

  /** @type {?|undefined} */
  this.skipRecalculationOfDeliveryFee;

  /** @type {?|undefined} */
  this.fixDeliveryFee;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.CalculateToUpdateRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.CalculateToUpdateRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  obj.addProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 2, obj.addProductsList.map(
          proto.stailer_external_admin.UpdateOrder.AddProduct.fromObject));
  obj.updateProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 3, obj.updateProductsList.map(
          proto.stailer_external_admin.UpdateOrder.UpdateProduct.fromObject));
  obj.skipRecalculationOfDeliveryFee != null && jspb.Message.setField(msg, 4, obj.skipRecalculationOfDeliveryFee);
  obj.fixDeliveryFee && jspb.Message.setWrapperField(
      msg, 5, proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.fromObject(obj.fixDeliveryFee));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.CalculateToUpdateRequest;
  return proto.stailer_external_admin.CalculateToUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.CalculateToUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.UpdateOrder.AddProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.AddProduct.deserializeBinaryFromReader);
      msg.addAddProducts(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.UpdateOrder.UpdateProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.UpdateProduct.deserializeBinaryFromReader);
      msg.addUpdateProducts(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipRecalculationOfDeliveryFee(value);
      break;
    case 5:
      var value = new proto.stailer_external_admin.UpdateOrder.FixDeliveryFee;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.deserializeBinaryFromReader);
      msg.setFixDeliveryFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.CalculateToUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.CalculateToUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CalculateToUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.stailer_external_admin.UpdateOrder.AddProduct.serializeBinaryToWriter
    );
  }
  f = message.getUpdateProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.stailer_external_admin.UpdateOrder.UpdateProduct.serializeBinaryToWriter
    );
  }
  f = message.getSkipRecalculationOfDeliveryFee();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFixDeliveryFee();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.serializeBinaryToWriter
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated UpdateOrder.AddProduct add_products = 2;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.getAddProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.AddProduct, 2));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
*/
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.setAddProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.addAddProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.stailer_external_admin.UpdateOrder.AddProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.clearAddProductsList = function() {
  return this.setAddProductsList([]);
};


/**
 * repeated UpdateOrder.UpdateProduct update_products = 3;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.getUpdateProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.UpdateProduct, 3));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
*/
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.setUpdateProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.addUpdateProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.stailer_external_admin.UpdateOrder.UpdateProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.clearUpdateProductsList = function() {
  return this.setUpdateProductsList([]);
};


/**
 * optional bool skip_recalculation_of_delivery_fee = 4;
 * @return {boolean}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.getSkipRecalculationOfDeliveryFee = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.setSkipRecalculationOfDeliveryFee = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional UpdateOrder.FixDeliveryFee fix_delivery_fee = 5;
 * @return {?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.getFixDeliveryFee = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.FixDeliveryFee, 5));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee|undefined} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
*/
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.setFixDeliveryFee = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.CalculateToUpdateRequest} returns this
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.clearFixDeliveryFee = function() {
  return this.setFixDeliveryFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.CalculateToUpdateRequest.prototype.hasFixDeliveryFee = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.CalculateToUpdateResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.CalculateToUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.CalculateToUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CalculateToUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    calculationResult: (f = msg.getCalculationResult()) && proto.stailer_external_admin.UpdateOrder.CalculationResult.toObject(includeInstance, f),
    bundledItemsList: jspb.Message.toObjectList(msg.getBundledItemsList(),
    type_bundled_item_pb.BundledItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CalculateToUpdateResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.CalculateToUpdateResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.calculationResult;

  /** @type {?|undefined} */
  this.bundledItemsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.CalculateToUpdateResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.CalculateToUpdateResponse();
  obj.calculationResult && jspb.Message.setWrapperField(
      msg, 1, proto.stailer_external_admin.UpdateOrder.CalculationResult.fromObject(obj.calculationResult));
  obj.bundledItemsList && jspb.Message.setRepeatedWrapperField(
      msg, 2, obj.bundledItemsList.map(
          type_bundled_item_pb.BundledItem.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.CalculateToUpdateResponse;
  return proto.stailer_external_admin.CalculateToUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.CalculateToUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.UpdateOrder.CalculationResult;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.CalculationResult.deserializeBinaryFromReader);
      msg.setCalculationResult(value);
      break;
    case 2:
      var value = new type_bundled_item_pb.BundledItem;
      reader.readMessage(value,type_bundled_item_pb.BundledItem.deserializeBinaryFromReader);
      msg.addBundledItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.CalculateToUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.CalculateToUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.CalculateToUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalculationResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stailer_external_admin.UpdateOrder.CalculationResult.serializeBinaryToWriter
    );
  }
  f = message.getBundledItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      type_bundled_item_pb.BundledItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateOrder.CalculationResult calculation_result = 1;
 * @return {?proto.stailer_external_admin.UpdateOrder.CalculationResult}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.getCalculationResult = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.CalculationResult} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.CalculationResult, 1));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.CalculationResult|undefined} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse} returns this
*/
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.setCalculationResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse} returns this
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.clearCalculationResult = function() {
  return this.setCalculationResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.hasCalculationResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated type.BundledItem bundled_items = 2;
 * @return {!Array<!proto.type.BundledItem>}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.getBundledItemsList = function() {
  return /** @type{!Array<!proto.type.BundledItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, type_bundled_item_pb.BundledItem, 2));
};


/**
 * @param {!Array<!proto.type.BundledItem>} value
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse} returns this
*/
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.setBundledItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.type.BundledItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.BundledItem}
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.addBundledItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.type.BundledItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.CalculateToUpdateResponse} returns this
 */
proto.stailer_external_admin.CalculateToUpdateResponse.prototype.clearBundledItemsList = function() {
  return this.setBundledItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.UpdateOrderRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    addProductsList: jspb.Message.toObjectList(msg.getAddProductsList(),
    proto.stailer_external_admin.UpdateOrder.AddProduct.toObject, includeInstance),
    updateProductsList: jspb.Message.toObjectList(msg.getUpdateProductsList(),
    proto.stailer_external_admin.UpdateOrder.UpdateProduct.toObject, includeInstance),
    skipRecalculationOfDeliveryFee: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    fixDeliveryFee: (f = msg.getFixDeliveryFee()) && proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.toObject(includeInstance, f),
    versionTimestamp: (f = msg.getVersionTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UpdateOrderRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;

  /** @type {?|undefined} */
  this.addProductsList;

  /** @type {?|undefined} */
  this.updateProductsList;

  /** @type {?|undefined} */
  this.skipRecalculationOfDeliveryFee;

  /** @type {?|undefined} */
  this.fixDeliveryFee;

  /** @type {?|undefined} */
  this.versionTimestamp;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest}
 */
proto.stailer_external_admin.UpdateOrderRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderRequest();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  obj.addProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 2, obj.addProductsList.map(
          proto.stailer_external_admin.UpdateOrder.AddProduct.fromObject));
  obj.updateProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 3, obj.updateProductsList.map(
          proto.stailer_external_admin.UpdateOrder.UpdateProduct.fromObject));
  obj.skipRecalculationOfDeliveryFee != null && jspb.Message.setField(msg, 4, obj.skipRecalculationOfDeliveryFee);
  obj.fixDeliveryFee && jspb.Message.setWrapperField(
      msg, 5, proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.fromObject(obj.fixDeliveryFee));
  obj.versionTimestamp && jspb.Message.setWrapperField(
      msg, 6, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.versionTimestamp));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest}
 */
proto.stailer_external_admin.UpdateOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderRequest;
  return proto.stailer_external_admin.UpdateOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest}
 */
proto.stailer_external_admin.UpdateOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.UpdateOrder.AddProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.AddProduct.deserializeBinaryFromReader);
      msg.addAddProducts(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.UpdateOrder.UpdateProduct;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.UpdateProduct.deserializeBinaryFromReader);
      msg.addUpdateProducts(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipRecalculationOfDeliveryFee(value);
      break;
    case 5:
      var value = new proto.stailer_external_admin.UpdateOrder.FixDeliveryFee;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.deserializeBinaryFromReader);
      msg.setFixDeliveryFee(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setVersionTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.stailer_external_admin.UpdateOrder.AddProduct.serializeBinaryToWriter
    );
  }
  f = message.getUpdateProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.stailer_external_admin.UpdateOrder.UpdateProduct.serializeBinaryToWriter
    );
  }
  f = message.getSkipRecalculationOfDeliveryFee();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFixDeliveryFee();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.stailer_external_admin.UpdateOrder.FixDeliveryFee.serializeBinaryToWriter
    );
  }
  f = message.getVersionTimestamp();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated UpdateOrder.AddProduct add_products = 2;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getAddProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.AddProduct, 2));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.AddProduct>} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
*/
proto.stailer_external_admin.UpdateOrderRequest.prototype.setAddProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.AddProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.AddProduct}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.addAddProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.stailer_external_admin.UpdateOrder.AddProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.clearAddProductsList = function() {
  return this.setAddProductsList([]);
};


/**
 * repeated UpdateOrder.UpdateProduct update_products = 3;
 * @return {!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getUpdateProductsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.UpdateOrder.UpdateProduct, 3));
};


/**
 * @param {!Array<!proto.stailer_external_admin.UpdateOrder.UpdateProduct>} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
*/
proto.stailer_external_admin.UpdateOrderRequest.prototype.setUpdateProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.stailer_external_admin.UpdateOrder.UpdateProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.UpdateOrder.UpdateProduct}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.addUpdateProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.stailer_external_admin.UpdateOrder.UpdateProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.clearUpdateProductsList = function() {
  return this.setUpdateProductsList([]);
};


/**
 * optional bool skip_recalculation_of_delivery_fee = 4;
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getSkipRecalculationOfDeliveryFee = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.setSkipRecalculationOfDeliveryFee = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional UpdateOrder.FixDeliveryFee fix_delivery_fee = 5;
 * @return {?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getFixDeliveryFee = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrder.FixDeliveryFee, 5));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrder.FixDeliveryFee|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
*/
proto.stailer_external_admin.UpdateOrderRequest.prototype.setFixDeliveryFee = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.clearFixDeliveryFee = function() {
  return this.setFixDeliveryFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.hasFixDeliveryFee = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp version_timestamp = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.getVersionTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
*/
proto.stailer_external_admin.UpdateOrderRequest.prototype.setVersionTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderRequest} returns this
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.clearVersionTimestamp = function() {
  return this.setVersionTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderRequest.prototype.hasVersionTimestamp = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.UpdateOrderResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1,
  OPTIMISTIC_LOCK_ERROR: 2,
  ASSUMED_STATUSES_VALIDATION_FAILED: 3,
  PAYMENT_FAILED: 4
};

/**
 * @return {proto.stailer_external_admin.UpdateOrderResponse.ResultCase}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.getResultCase = function() {
  return /** @type {proto.stailer_external_admin.UpdateOrderResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.stailer_external_admin.UpdateOrderResponse.Success.toObject(includeInstance, f),
    optimisticLockError: (f = msg.getOptimisticLockError()) && proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.toObject(includeInstance, f),
    assumedStatusesValidationFailed: (f = msg.getAssumedStatusesValidationFailed()) && proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.toObject(includeInstance, f),
    paymentFailed: (f = msg.getPaymentFailed()) && proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of UpdateOrderResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.success;

  /** @type {?|undefined} */
  this.optimisticLockError;

  /** @type {?|undefined} */
  this.assumedStatusesValidationFailed;

  /** @type {?|undefined} */
  this.paymentFailed;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse}
 */
proto.stailer_external_admin.UpdateOrderResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderResponse();
  obj.success && jspb.Message.setWrapperField(
      msg, 1, proto.stailer_external_admin.UpdateOrderResponse.Success.fromObject(obj.success));
  obj.optimisticLockError && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.fromObject(obj.optimisticLockError));
  obj.assumedStatusesValidationFailed && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.fromObject(obj.assumedStatusesValidationFailed));
  obj.paymentFailed && jspb.Message.setWrapperField(
      msg, 4, proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.fromObject(obj.paymentFailed));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse}
 */
proto.stailer_external_admin.UpdateOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderResponse;
  return proto.stailer_external_admin.UpdateOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse}
 */
proto.stailer_external_admin.UpdateOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.UpdateOrderResponse.Success;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrderResponse.Success.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.deserializeBinaryFromReader);
      msg.setOptimisticLockError(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.deserializeBinaryFromReader);
      msg.setAssumedStatusesValidationFailed(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed;
      reader.readMessage(value,proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.deserializeBinaryFromReader);
      msg.setPaymentFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stailer_external_admin.UpdateOrderResponse.Success.serializeBinaryToWriter
    );
  }
  f = message.getOptimisticLockError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.serializeBinaryToWriter
    );
  }
  f = message.getAssumedStatusesValidationFailed();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.serializeBinaryToWriter
    );
  }
  f = message.getPaymentFailed();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderResponse.Success.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.Success} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Success as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.Success.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.Success}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.Success();
  obj.orderId != null && jspb.Message.setField(msg, 1, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.Success}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.Success;
  return proto.stailer_external_admin.UpdateOrderResponse.Success.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.Success} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.Success}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderResponse.Success.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.Success} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.Success} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.Success.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorMessage: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OptimisticLockError as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.errorMessage;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError();
  obj.errorMessage != null && jspb.Message.setField(msg, 1, obj.errorMessage);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError;
  return proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error_message = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorMessage: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AssumedStatusesValidationFailed as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.errorMessage;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed();
  obj.errorMessage != null && jspb.Message.setField(msg, 1, obj.errorMessage);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed;
  return proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error_message = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorMessage: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PaymentFailed as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.errorMessage;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed();
  obj.errorMessage != null && jspb.Message.setField(msg, 1, obj.errorMessage);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed;
  return proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error_message = 1;
 * @return {string}
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Success success = 1;
 * @return {?proto.stailer_external_admin.UpdateOrderResponse.Success}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.getSuccess = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrderResponse.Success} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrderResponse.Success, 1));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrderResponse.Success|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
*/
proto.stailer_external_admin.UpdateOrderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OptimisticLockError optimistic_lock_error = 2;
 * @return {?proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.getOptimisticLockError = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError, 2));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrderResponse.OptimisticLockError|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
*/
proto.stailer_external_admin.UpdateOrderResponse.prototype.setOptimisticLockError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.clearOptimisticLockError = function() {
  return this.setOptimisticLockError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.hasOptimisticLockError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AssumedStatusesValidationFailed assumed_statuses_validation_failed = 3;
 * @return {?proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.getAssumedStatusesValidationFailed = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed, 3));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrderResponse.AssumedStatusesValidationFailed|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
*/
proto.stailer_external_admin.UpdateOrderResponse.prototype.setAssumedStatusesValidationFailed = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.clearAssumedStatusesValidationFailed = function() {
  return this.setAssumedStatusesValidationFailed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.hasAssumedStatusesValidationFailed = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PaymentFailed payment_failed = 4;
 * @return {?proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.getPaymentFailed = function() {
  return /** @type{?proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed, 4));
};


/**
 * @param {?proto.stailer_external_admin.UpdateOrderResponse.PaymentFailed|undefined} value
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
*/
proto.stailer_external_admin.UpdateOrderResponse.prototype.setPaymentFailed = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.stailer_external_admin.UpdateOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.UpdateOrderResponse} returns this
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.clearPaymentFailed = function() {
  return this.setPaymentFailed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.UpdateOrderResponse.prototype.hasPaymentFailed = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsPeriod as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.startDate;

  /** @type {?|undefined} */
  this.endDate;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsPeriod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsPeriod();
  obj.startDate && jspb.Message.setWrapperField(
      msg, 1, google_type_date_pb.Date.fromObject(obj.startDate));
  obj.endDate && jspb.Message.setWrapperField(
      msg, 2, google_type_date_pb.Date.fromObject(obj.endDate));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsPeriod;
  return proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Date start_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.getStartDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod} returns this
*/
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod} returns this
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.type.Date end_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.getEndDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod} returns this
*/
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsPeriod} returns this
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsPeriod.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsDeliveryTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsDeliveryTime as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsDeliveryTime();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsDeliveryTime;
  return proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsDeliveryTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsDeliveryTime} returns this
 */
proto.stailer_external_admin.SearchOrderProductsDeliveryTime.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.ConditionCase = {
  CONDITION_NOT_SET: 0,
  PERIOD: 3,
  DELIVERY_TIME: 4
};

/**
 * @return {proto.stailer_external_admin.SearchOrderProductsStreamRequest.ConditionCase}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.getConditionCase = function() {
  return /** @type {proto.stailer_external_admin.SearchOrderProductsStreamRequest.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.SearchOrderProductsStreamRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    period: (f = msg.getPeriod()) && proto.stailer_external_admin.SearchOrderProductsPeriod.toObject(includeInstance, f),
    deliveryTime: (f = msg.getDeliveryTime()) && proto.stailer_external_admin.SearchOrderProductsDeliveryTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsStreamRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.query;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.period;

  /** @type {?|undefined} */
  this.deliveryTime;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamRequest();
  obj.query != null && jspb.Message.setField(msg, 1, obj.query);
  obj.shopId != null && jspb.Message.setField(msg, 2, obj.shopId);
  obj.period && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.SearchOrderProductsPeriod.fromObject(obj.period));
  obj.deliveryTime && jspb.Message.setWrapperField(
      msg, 4, proto.stailer_external_admin.SearchOrderProductsDeliveryTime.fromObject(obj.deliveryTime));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamRequest;
  return proto.stailer_external_admin.SearchOrderProductsStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.SearchOrderProductsPeriod;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinaryFromReader);
      msg.setPeriod(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.SearchOrderProductsDeliveryTime;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinaryFromReader);
      msg.setDeliveryTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.SearchOrderProductsPeriod.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.stailer_external_admin.SearchOrderProductsDeliveryTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string shop_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SearchOrderProductsPeriod period = 3;
 * @return {?proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.getPeriod = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsPeriod} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsPeriod, 3));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsPeriod|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.setPeriod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.stailer_external_admin.SearchOrderProductsStreamRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.clearPeriod = function() {
  return this.setPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.hasPeriod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SearchOrderProductsDeliveryTime delivery_time = 4;
 * @return {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.getDeliveryTime = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsDeliveryTime} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsDeliveryTime, 4));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.setDeliveryTime = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.stailer_external_admin.SearchOrderProductsStreamRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.clearDeliveryTime = function() {
  return this.setDeliveryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsStreamRequest.prototype.hasDeliveryTime = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsStreamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsStreamResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.resultsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamResponse();
  obj.resultsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.resultsList.map(
          proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamResponse;
  return proto.stailer_external_admin.SearchOrderProductsStreamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsStreamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.toObject = function(includeInstance, msg) {
  var f, obj = {
    productImageUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    productName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    stockOutAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    deliveryTime: (f = msg.getDeliveryTime()) && stailer_externaladminrpc_delivery_time_pb.DeliveryTime.toObject(includeInstance, f),
    orderLabelNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Result as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productImageUrl;

  /** @type {?|undefined} */
  this.productName;

  /** @type {?|undefined} */
  this.amount;

  /** @type {?|undefined} */
  this.stockOutAmount;

  /** @type {?|undefined} */
  this.deliveryTime;

  /** @type {?|undefined} */
  this.orderLabelNumber;

  /** @type {?|undefined} */
  this.orderId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result();
  obj.productImageUrl != null && jspb.Message.setField(msg, 1, obj.productImageUrl);
  obj.productName != null && jspb.Message.setField(msg, 2, obj.productName);
  obj.amount != null && jspb.Message.setField(msg, 3, obj.amount);
  obj.stockOutAmount != null && jspb.Message.setField(msg, 4, obj.stockOutAmount);
  obj.deliveryTime && jspb.Message.setWrapperField(
      msg, 5, stailer_externaladminrpc_delivery_time_pb.DeliveryTime.fromObject(obj.deliveryTime));
  obj.orderLabelNumber != null && jspb.Message.setField(msg, 6, obj.orderLabelNumber);
  obj.orderId != null && jspb.Message.setField(msg, 7, obj.orderId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result;
  return proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductImageUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStockOutAmount(value);
      break;
    case 5:
      var value = new stailer_externaladminrpc_delivery_time_pb.DeliveryTime;
      reader.readMessage(value,stailer_externaladminrpc_delivery_time_pb.DeliveryTime.deserializeBinaryFromReader);
      msg.setDeliveryTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderLabelNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductImageUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStockOutAmount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDeliveryTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      stailer_externaladminrpc_delivery_time_pb.DeliveryTime.serializeBinaryToWriter
    );
  }
  f = message.getOrderLabelNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string product_image_url = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getProductImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setProductImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_name = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 amount = 3;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 stock_out_amount = 4;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getStockOutAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setStockOutAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional DeliveryTime delivery_time = 5;
 * @return {?proto.stailer_external_admin.DeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getDeliveryTime = function() {
  return /** @type{?proto.stailer_external_admin.DeliveryTime} */ (
    jspb.Message.getWrapperField(this, stailer_externaladminrpc_delivery_time_pb.DeliveryTime, 5));
};


/**
 * @param {?proto.stailer_external_admin.DeliveryTime|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
*/
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setDeliveryTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.clearDeliveryTime = function() {
  return this.setDeliveryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.hasDeliveryTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string order_label_number = 6;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getOrderLabelNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setOrderLabelNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string order_id = 7;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Result results = 1;
 * @return {!Array<!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result>}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result>} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse} returns this
*/
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.SearchOrderProductsStreamResponse.Result, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrderProductsStreamResponse} returns this
 */
proto.stailer_external_admin.SearchOrderProductsStreamResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsRequest.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.ConditionCase = {
  CONDITION_NOT_SET: 0,
  PERIOD: 3,
  DELIVERY_TIME: 4
};

/**
 * @return {proto.stailer_external_admin.SearchOrderProductsRequest.ConditionCase}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getConditionCase = function() {
  return /** @type {proto.stailer_external_admin.SearchOrderProductsRequest.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.SearchOrderProductsRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productMatchingQuery: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    period: (f = msg.getPeriod()) && proto.stailer_external_admin.SearchOrderProductsPeriod.toObject(includeInstance, f),
    deliveryTime: (f = msg.getDeliveryTime()) && proto.stailer_external_admin.SearchOrderProductsDeliveryTime.toObject(includeInstance, f),
    cursor: jspb.Message.getFieldWithDefault(msg, 5, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productMatchingQuery;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.period;

  /** @type {?|undefined} */
  this.deliveryTime;

  /** @type {?|undefined} */
  this.cursor;

  /** @type {?|undefined} */
  this.responseType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsRequest();
  obj.productMatchingQuery != null && jspb.Message.setField(msg, 1, obj.productMatchingQuery);
  obj.shopId != null && jspb.Message.setField(msg, 2, obj.shopId);
  obj.period && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.SearchOrderProductsPeriod.fromObject(obj.period));
  obj.deliveryTime && jspb.Message.setWrapperField(
      msg, 4, proto.stailer_external_admin.SearchOrderProductsDeliveryTime.fromObject(obj.deliveryTime));
  obj.cursor != null && jspb.Message.setField(msg, 5, obj.cursor);
  obj.responseType != null && jspb.Message.setField(msg, 6, obj.responseType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsRequest;
  return proto.stailer_external_admin.SearchOrderProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductMatchingQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.SearchOrderProductsPeriod;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinaryFromReader);
      msg.setPeriod(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.SearchOrderProductsDeliveryTime;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinaryFromReader);
      msg.setDeliveryTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 6:
      var value = /** @type {!proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductMatchingQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.SearchOrderProductsPeriod.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.stailer_external_admin.SearchOrderProductsDeliveryTime.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType = {
  RESPONSE_TYPE_NONE: 0,
  RESPONSE_TYPE_CSV: 1,
  RESPONSE_TYPE_STRUCTURED: 2
};

/**
 * optional string product_matching_query = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getProductMatchingQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setProductMatchingQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string shop_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SearchOrderProductsPeriod period = 3;
 * @return {?proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getPeriod = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsPeriod} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsPeriod, 3));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsPeriod|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setPeriod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.stailer_external_admin.SearchOrderProductsRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.clearPeriod = function() {
  return this.setPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.hasPeriod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SearchOrderProductsDeliveryTime delivery_time = 4;
 * @return {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getDeliveryTime = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsDeliveryTime} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsDeliveryTime, 4));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setDeliveryTime = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.stailer_external_admin.SearchOrderProductsRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.clearDeliveryTime = function() {
  return this.setDeliveryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.hasDeliveryTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string cursor = 5;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ResponseType response_type = 6;
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType}
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.getResponseType = function() {
  return /** @type {!proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.stailer_external_admin.SearchOrderProductsRequest.ResponseType} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsRequest.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsResponse.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseTypeCase = {
  RESPONSE_TYPE_NOT_SET: 0,
  STRUCTURED: 2,
  CSV: 3
};

/**
 * @return {proto.stailer_external_admin.SearchOrderProductsResponse.ResponseTypeCase}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.getResponseTypeCase = function() {
  return /** @type {proto.stailer_external_admin.SearchOrderProductsResponse.ResponseTypeCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.SearchOrderProductsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    structured: (f = msg.getStructured()) && proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.toObject(includeInstance, f),
    csv: (f = msg.getCsv()) && proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.cursor;

  /** @type {?|undefined} */
  this.structured;

  /** @type {?|undefined} */
  this.csv;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse();
  obj.cursor != null && jspb.Message.setField(msg, 1, obj.cursor);
  obj.structured && jspb.Message.setWrapperField(
      msg, 2, proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.fromObject(obj.structured));
  obj.csv && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.fromObject(obj.csv));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse;
  return proto.stailer_external_admin.SearchOrderProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 2:
      var value = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.deserializeBinaryFromReader);
      msg.setStructured(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.deserializeBinaryFromReader);
      msg.setCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStructured();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.serializeBinaryToWriter
    );
  }
  f = message.getCsv();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsResponse.Result.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.toObject = function(includeInstance, msg) {
  var f, obj = {
    productImageUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    productName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deliveryAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    stockOutAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderAssignedDeliveryCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    deliveryTimeDescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
    displayableDeliveryDate: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Result as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productImageUrl;

  /** @type {?|undefined} */
  this.productName;

  /** @type {?|undefined} */
  this.deliveryAmount;

  /** @type {?|undefined} */
  this.stockOutAmount;

  /** @type {?|undefined} */
  this.orderAssignedDeliveryCode;

  /** @type {?|undefined} */
  this.orderId;

  /** @type {?|undefined} */
  this.deliveryTimeDescription;

  /** @type {?|undefined} */
  this.displayableDeliveryDate;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.Result.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.Result();
  obj.productImageUrl != null && jspb.Message.setField(msg, 1, obj.productImageUrl);
  obj.productName != null && jspb.Message.setField(msg, 2, obj.productName);
  obj.deliveryAmount != null && jspb.Message.setField(msg, 3, obj.deliveryAmount);
  obj.stockOutAmount != null && jspb.Message.setField(msg, 4, obj.stockOutAmount);
  obj.orderAssignedDeliveryCode != null && jspb.Message.setField(msg, 6, obj.orderAssignedDeliveryCode);
  obj.orderId != null && jspb.Message.setField(msg, 7, obj.orderId);
  obj.deliveryTimeDescription != null && jspb.Message.setField(msg, 8, obj.deliveryTimeDescription);
  obj.displayableDeliveryDate != null && jspb.Message.setField(msg, 9, obj.displayableDeliveryDate);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.Result;
  return proto.stailer_external_admin.SearchOrderProductsResponse.Result.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductImageUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeliveryAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStockOutAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderAssignedDeliveryCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveryTimeDescription(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayableDeliveryDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsResponse.Result.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductImageUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeliveryAmount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStockOutAmount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOrderAssignedDeliveryCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDeliveryTimeDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDisplayableDeliveryDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string product_image_url = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getProductImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setProductImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_name = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 delivery_amount = 3;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getDeliveryAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setDeliveryAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 stock_out_amount = 4;
 * @return {number}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getStockOutAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setStockOutAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string order_assigned_delivery_code = 6;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getOrderAssignedDeliveryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setOrderAssignedDeliveryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string order_id = 7;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string delivery_time_description = 8;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getDeliveryTimeDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setDeliveryTimeDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string displayable_delivery_date = 9;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.getDisplayableDeliveryDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.Result.prototype.setDisplayableDeliveryDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.stailer_external_admin.SearchOrderProductsResponse.Result.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ResponseByTypeStructured as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.resultsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured();
  obj.resultsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.resultsList.map(
          proto.stailer_external_admin.SearchOrderProductsResponse.Result.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured;
  return proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stailer_external_admin.SearchOrderProductsResponse.Result;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsResponse.Result.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stailer_external_admin.SearchOrderProductsResponse.Result.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Result results = 1;
 * @return {!Array<!proto.stailer_external_admin.SearchOrderProductsResponse.Result>}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.stailer_external_admin.SearchOrderProductsResponse.Result>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stailer_external_admin.SearchOrderProductsResponse.Result, 1));
};


/**
 * @param {!Array<!proto.stailer_external_admin.SearchOrderProductsResponse.Result>} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} returns this
*/
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.Result=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.Result}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stailer_external_admin.SearchOrderProductsResponse.Result, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.toObject = function(includeInstance, msg) {
  var f, obj = {
    csvData: msg.getCsvData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ResponseByTypeCsv as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.csvData;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv();
  obj.csvData != null && jspb.Message.setField(msg, 1, obj.csvData);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv;
  return proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes csv_data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.getCsvData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes csv_data = 1;
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.getCsvData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvData()));
};


/**
 * optional bytes csv_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.getCsvData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string cursor = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ResponseByTypeStructured structured = 2;
 * @return {?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.getStructured = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured, 2));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeStructured|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse} returns this
*/
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.setStructured = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.stailer_external_admin.SearchOrderProductsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.clearStructured = function() {
  return this.setStructured(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.hasStructured = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ResponseByTypeCsv csv = 3;
 * @return {?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.getCsv = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv, 3));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsResponse.ResponseByTypeCsv|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse} returns this
*/
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.setCsv = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.stailer_external_admin.SearchOrderProductsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsResponse} returns this
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.clearCsv = function() {
  return this.setCsv(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsResponse.prototype.hasCsv = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ConditionCase = {
  CONDITION_NOT_SET: 0,
  PERIOD: 3,
  DELIVERY_TIME: 4
};

/**
 * @return {proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ConditionCase}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.getConditionCase = function() {
  return /** @type {proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    period: (f = msg.getPeriod()) && proto.stailer_external_admin.SearchOrderProductsPeriod.toObject(includeInstance, f),
    deliveryTime: (f = msg.getDeliveryTime()) && proto.stailer_external_admin.SearchOrderProductsDeliveryTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsCsvStreamRequest as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.query;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.period;

  /** @type {?|undefined} */
  this.deliveryTime;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest();
  obj.query != null && jspb.Message.setField(msg, 1, obj.query);
  obj.shopId != null && jspb.Message.setField(msg, 2, obj.shopId);
  obj.period && jspb.Message.setWrapperField(
      msg, 3, proto.stailer_external_admin.SearchOrderProductsPeriod.fromObject(obj.period));
  obj.deliveryTime && jspb.Message.setWrapperField(
      msg, 4, proto.stailer_external_admin.SearchOrderProductsDeliveryTime.fromObject(obj.deliveryTime));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest;
  return proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 3:
      var value = new proto.stailer_external_admin.SearchOrderProductsPeriod;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsPeriod.deserializeBinaryFromReader);
      msg.setPeriod(value);
      break;
    case 4:
      var value = new proto.stailer_external_admin.SearchOrderProductsDeliveryTime;
      reader.readMessage(value,proto.stailer_external_admin.SearchOrderProductsDeliveryTime.deserializeBinaryFromReader);
      msg.setDeliveryTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.stailer_external_admin.SearchOrderProductsPeriod.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.stailer_external_admin.SearchOrderProductsDeliveryTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string shop_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SearchOrderProductsPeriod period = 3;
 * @return {?proto.stailer_external_admin.SearchOrderProductsPeriod}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.getPeriod = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsPeriod} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsPeriod, 3));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsPeriod|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.setPeriod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.clearPeriod = function() {
  return this.setPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.hasPeriod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SearchOrderProductsDeliveryTime delivery_time = 4;
 * @return {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.getDeliveryTime = function() {
  return /** @type{?proto.stailer_external_admin.SearchOrderProductsDeliveryTime} */ (
    jspb.Message.getWrapperField(this, proto.stailer_external_admin.SearchOrderProductsDeliveryTime, 4));
};


/**
 * @param {?proto.stailer_external_admin.SearchOrderProductsDeliveryTime|undefined} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
*/
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.setDeliveryTime = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest} returns this
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.clearDeliveryTime = function() {
  return this.setDeliveryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamRequest.prototype.hasDeliveryTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SearchOrderProductsCsvStreamResponse as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.data;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse();
  obj.data != null && jspb.Message.setField(msg, 1, obj.data);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse;
  return proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse} returns this
 */
proto.stailer_external_admin.SearchOrderProductsCsvStreamResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


goog.object.extend(exports, proto.stailer_external_admin);
